/**
 * scssを読み込み
 */
import './scss/style.scss';

/**
 * jQueryを読み込み
 */
import $ from 'jquery';

/**
 * Slickを読み込み
 */
import 'slick-carousel';

/**
 * scriptを読み込み
 */
import './js/script.js';
import './js/header.js';
import './js/toggleSlide.js';
import './js/img-fallback.js';
import './js/product.js';
import './js/a-blog_config.js';
import './js/target_blank.js';
import './js/scroll_animation.js';
